<template>
  <div class="pa-4 d-flex align-center">
    <span class="pl-4 grey--text text-subtitle-2">{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: 'DuaMessageOk',

  props: {
    message: {
      type: String,
      default: 'Status: behandlad'
    }
  }
}
</script>
